import { AccessControlProvider } from "@refinedev/core";
import { IUserData, PermissionAction } from "interfaces";

const getPermissionActionByModuleAction = (action: string) => {
  switch (action) {
    case "list":
      return PermissionAction.VIEW;
    case "create":
      return PermissionAction.CREATE;
    case "edit":
      return PermissionAction.EDIT;
    case "show":
      return PermissionAction.VIEW;
    case "clone":
      return PermissionAction.VIEW;
    default:
      return "";
  }
};

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action, params }) => {
    if (!resource) {
      return {
        can: true,
      };
    }
    
    const moduleApp = params?.resource?.meta?.app ?? "";
    const moduleResource = params?.resource?.meta?.resource ?? "";
    // if (!moduleApp && !moduleResource) return {can: true};
    const user = JSON.parse(localStorage.getItem("USER") ?? "{}");
    const permissions: IUserData["permissions"] = user?.permissions ?? [];

    // Find permission
    const permission = permissions.find(
      (p) => p.resource === moduleResource && p.app === moduleApp
    );

    if (!permission) {
      return {
        can: false,
        reason: "No permission found for this resource",
      };
    }
    
    // Check action
    const hasAction = permission.action.includes(
      getPermissionActionByModuleAction(action) as PermissionAction
    );

    return {
      can: hasAction,
      reason: hasAction
        ? undefined
        : `Action '${action}' not allowed for resource '${resource}'`,
    };
  },
};
